import produce from "immer";
import * as actionTypes from "../actions/actionTypes";

const initialState = {
  numGridCols:
    Math.floor(window.innerWidth / 150) < 1
      ? 1
      : Math.floor(window.innerWidth / 150) > 12
      ? 12
      : Math.floor(window.innerWidth / 150),
};

export default produce((draft, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SET_NUM_GRID_COLUMNS:
      draft.numGridCols = payload;
      return;
    default:
      return;
  }
}, initialState);
